import { css } from 'twin.macro';
import { Fragment, useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Row } from 'react-bootstrap';
import SideBar from '../Layouts/SideBar/SideBar';
import { getAllRooms } from '../../../_redux';
import { clearActivity, clearActivities, getActivities } from '../../../_redux/actions/ActionActivity';
import { markAllAsReadActivities } from '../../../_redux/actions/ActionActivity';
import { MdClearAll } from 'react-icons/md';
import { ActivityContainerStyled } from './ActivityContainerStyles';
import MessageListener from '../Common/MessageListener';
import SingleActivity from './SingleActivity';
import { UPrimaryButton } from '../../../_elements/Buttons';
import { getTheDate } from '../../../_helpers';
import Loader from '../../../components/Admin/containers/Loader';
import { HiChevronDoubleUp } from 'react-icons/hi';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useMemo } from 'react';
import { FaArrowDown } from 'react-icons/fa';
import { VscLoading } from 'react-icons/vsc';
import Swal from 'sweetalert2';

const ActivityContainer = ({
    activities,
    getAllRooms,
    rooms,
    clearActivities,
    clearActivity,
    markAllAsReadActivities,
    loading,
    getActivities,
    totalActivities,
}) => {
    const [isClearBtnAnimation, setIsClearBtnAnimation] = useState(false);
    const [isMarkReadBtnAnimation, setIsMarkReadBtnAnimation] = useState(false);
    const [mobileSidebar, setMobileSidebar] = useState(false);
    useEffect(() => {
        if (rooms.length === 0) {
            getAllRooms();
        }
    }, [getAllRooms, rooms]);

    const handleClearBtnClick = async () => {
        const result = await Swal.fire({
            title: 'Do you confirm creating clearing all activities?',
            text: '',
            icon: 'warning',
            showCancelButton: true,
            // confirmButtonColor: '#50aeb0',
            // cancelButtonColor: '#d33',
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
        });
        if (result?.isConfirmed) {
            setIsClearBtnAnimation(true);
            // Handle Api Call to clear the acitivity.
            clearActivities();
        }
    };

    const handleSingleClearBtnClick = (id) => {
        // setIsClearBtnAnimation(true);
        // Handle Api Call to clear the acitivity.
        clearActivity(id);
    };

    const handleMarkReadBtnClick = async () => {
        const result = await Swal.fire({
            title: 'Do you confirm marking all activities as read?',
            text: '',
            icon: 'warning',
            showCancelButton: true,
            // confirmButtonColor: '#50aeb0',
            // cancelButtonColor: '#d33',
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
        });
        if (result?.isConfirmed) {
            setIsMarkReadBtnAnimation(true);
            markAllAsReadActivities();
        }
    };

    const groups = useMemo(() => {
        return activities.reduce((groups, act) => {
            const date = getTheDate(new Date(act.createdAt));
            if (!groups[date]) {
                groups[date] = [];
            }
            groups[date].push(act);
            return groups;
        }, {});
    }, [activities]);
    const hasMoreActivities = (activities || []).length < (totalActivities || 0);

    useEffect(() => {
        getActivities({});
    }, []);

    return (
        <Row className="m-0 p-0">
            <MessageListener />
            <SwitchTransition>
                <CSSTransition key={mobileSidebar} timeout={500} classNames={'sidebar-ani-'}>
                    <SideBar mobileSidebar={mobileSidebar} setMobileSidebar={setMobileSidebar} />
                </CSSTransition>
            </SwitchTransition>
            <ActivityContainerStyled>
                <div className="d-flex w-100 justify-content-between">
                    <h1
                        css={css`
                            color: #757575;
                            font-weight: bold;
                            margin-left: 10px;
                        `}
                    >
                        Activity
                    </h1>

                    <div>
                        {activities.length > 0 && (
                            <div className="d-flex">
                                <UPrimaryButton
                                    className={`mr-4 ${isClearBtnAnimation ? 'animation-scaleUpDown' : ''}`}
                                    onClick={handleClearBtnClick}
                                    onAnimationEnd={() => setIsClearBtnAnimation(false)}
                                >
                                    <MdClearAll size="24" />
                                    <span className="ml-2">Clear all activities</span>
                                </UPrimaryButton>

                                <UPrimaryButton
                                    className={`mr-4 ${isMarkReadBtnAnimation ? 'animation-scaleUpDown' : ''}`}
                                    onClick={handleMarkReadBtnClick}
                                    onAnimationEnd={() => setIsMarkReadBtnAnimation(false)}
                                >
                                    <i className="fas fa-check"></i>
                                    <span className="ml-2">Mark all as read</span>
                                </UPrimaryButton>
                            </div>
                        )}
                    </div>
                </div>

                <div className="activity">
                    {activities.length > 0 ? (
                        <Fragment>
                            {Object.keys(groups).map((date) => (
                                <div key={date}>
                                    <div className="actDate mt-4">{date}</div>
                                    <div className="mt-4">
                                        {groups[date] &&
                                            groups[date].length > 0 &&
                                            groups[date].map((act) => (
                                                <SingleActivity
                                                    key={act._id}
                                                    activity={act}
                                                    handleClear={handleSingleClearBtnClick}
                                                />
                                            ))}
                                    </div>
                                </div>
                            ))}
                            <div className="d-flex justify-content-center ">
                                {hasMoreActivities ? (
                                    <Button
                                        className="w-50"
                                        onClick={() => {
                                            const page = Math.floor((activities || []).length / 10) + 1;
                                            getActivities({
                                                page,
                                            });
                                        }}
                                        disabled={!hasMoreActivities || loading}
                                    >
                                        Load More Activities
                                        {loading ? (
                                            <VscLoading className="spin ml-3" />
                                        ) : (
                                            <FaArrowDown className="ml-3" />
                                        )}
                                    </Button>
                                ) : (
                                    <div>No more activities</div>
                                )}
                            </div>
                        </Fragment>
                    ) : loading ? (
                        <Loader size="sm" />
                    ) : (
                        <div className="space-entire align-center">
                            <p className="text-dark">No activities at the moment</p>
                        </div>
                    )}
                </div>
            </ActivityContainerStyled>
            <div className="sidebar-toggle" onClick={() => setMobileSidebar(!mobileSidebar)}>
                {!mobileSidebar && <HiChevronDoubleUp />}
            </div>
        </Row>
    );
};

ActivityContainer.propTypes = {};

const mapStateToProps = (state) => ({
    activities: state.activities.activities,
    totalActivities: state.activities.totalActivities,
    rooms: state.rooms.teamRooms,
    loading: state.ui.loading,
});

const mapDispatchToProps = { getAllRooms, clearActivities, clearActivity, markAllAsReadActivities, getActivities };

export default connect(mapStateToProps, mapDispatchToProps)(ActivityContainer);
